<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <v-card elevation="10">
                <div class="pa-3">
                    <DamagedTotal total="100"/>
                </div>
                <div class="pa-4">
                    <v-card-title>
                        <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="dropHeaders" :items="dropList" :search="search">
                        <template v-slot:item="dataDetail" class="grid_btn">
                            <tr>
                                <td><v-checkbox color="#86bc3a" v-model="dataDetail.item.status_manage"/></td>
                                <td>{{ dataDetail.item.refun_lot }}</td>
                                <td>{{ dataDetail.item.refun_date }}</td>
                                <td>{{ dataDetail.item.refun_total }} {{ dataDetail.item.refun_type }}</td>
                                <td>{{ dataDetail.item.supplier }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
                <div class="pa-6 text-right">
                    <v-btn x-large class="grad-warning-bg white--text">ย้ายเข้าคลังทิ้ง</v-btn>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
    import DamagedTotal from "./header_damaged/DamagedTotal";
    export default {
        name: "Damaged_drop",
        components: {DamagedTotal},
        data() {
            return {
                loading_page: false,
                search: null,
                dropHeaders: [
                    {
                        text: 'จัดการ',
                        value: 'status_manage',
                    },
                    {
                        text: 'ล็อตสินค้า',
                        value: 'refun_lot',
                    },
                    {
                        text: 'วันหมดอายุ',
                        value: 'fefun_date',
                    },
                    {
                        text: 'จำนวนคงเหลือ',
                        value: 'refun_total',
                    },
                    {
                        text: 'ซัพพลายเออร์',
                        value: 'supplier',
                    },
                ],
                dropList: [
                    {
                        id: 1,
                        status_manage: true,
                        refun_lot: 'Des65d18',
                        refun_date: '12/12/64',
                        refun_total: 45,
                        refun_type: 'ซอง',
                        supplier: 'บริษัท ซิลิค จำกัด',
                        status_cn: true
                    },
                    {
                        id: 1,
                        status_manage: true,
                        refun_lot: 'Des65d18',
                        refun_date: '12/12/64',
                        refun_total: 45,
                        refun_type: 'ซอง',
                        supplier: 'บริษัท ซิลิค จำกัด',
                        status_cn: true
                    },
                    {
                        id: 2,
                        status_manage: false,
                        refun_lot: 'Des65d18',
                        refun_date: '12/12/64',
                        refun_total: 45,
                        refun_type: 'ซอง',
                        supplier: 'บริษัท ซิลิค จำกัด',
                        status_cn: true
                    },
                    {
                        id: 3,
                        status_manage: false,
                        refun_lot: 'Des65d18',
                        refun_date: '12/12/64',
                        refun_total: 45,
                        refun_type: 'ซอง',
                        supplier: 'บริษัท ซิลิค จำกัด',
                        status_cn: false
                    },
                    {
                        id: 4,
                        status_manage: true,
                        refun_lot: 'Des65d18',
                        refun_date: '12/12/64',
                        refun_total: 45,
                        refun_type: 'ซอง',
                        supplier: 'บริษัท ซิลิค จำกัด',
                        status_cn: true
                    },
                ],
            }
        }
    }
</script>

<style scoped>

</style>
